import { render, staticRenderFns } from "./EventScript.vue?vue&type=template&id=5ff8e932&scoped=true"
import script from "./EventScript.vue?vue&type=script&lang=js"
export * from "./EventScript.vue?vue&type=script&lang=js"
import style0 from "./EventScript.vue?vue&type=style&index=0&id=5ff8e932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff8e932",
  null
  
)

export default component.exports